import { hasSubscriptionAccess, hasApplicationsAccess, isSuperUser } from '@/util'
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  Label,
  Input,
  DialogActions,
  DialogTrigger,
} from '@fluentui/react-components'
import { useState } from 'react'
import { PWC_ID_CONFIG } from '@/const'
import { useSessionStorage, useLogout, useSetRedis } from '@/hooks'
import {
  IconAvatarOutline,
  IconDesktopOutline,
  IconDuplicateOutline,
  IconImageOutline,
  IconLightbulbOutline,
  IconLoginOutline,
  IconLogoutOutline,
  IconMenuOutline,
  IconOrgChartOutline,
} from '@/components/icons'
import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuGroup,
} from '@/components/shadcn/dropdown-menu'
import { Link } from 'react-router-dom'

export function UserWidget2() {
  const [token] = useSessionStorage('token', '')
  const [roles] = useSessionStorage('roles', 0)
  const loggedIn = !!token
  const { logoutHandler } = useLogout()
  const setRedis = useSetRedis()
  const [open, onOpenChange] = useState(false)

  const [setRedisDialogOpen, setSetRedisDialogOpen] = useState<boolean>(false)
  const [key, setKey] = useState<string>('')
  const [value, setValue] = useState<string>('')

  const redisFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setRedis(key, value)
  }

  const closeMenu = () => onOpenChange(false)

  return (
    <>
      <DropdownMenu open={open} onOpenChange={onOpenChange}>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" className="rounded-full">
            <IconMenuOutline className="size-5" />
            <IconAvatarOutline className="size-5" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {loggedIn && (
            <DropdownMenuGroup>
              <DropdownMenuItem onClick={logoutHandler}>
                <IconLogoutOutline className="mr-2 size-4" />
                Logout
              </DropdownMenuItem>
              {hasSubscriptionAccess(roles) && (
                <Link className="text-foreground" to="/subscriptions">
                  <DropdownMenuItem onSelect={closeMenu}>
                    <IconOrgChartOutline className="mr-2 size-4" />
                    Subscriptions
                  </DropdownMenuItem>
                </Link>
              )}
              {hasApplicationsAccess(roles) && (
                <Link className="text-foreground" to="/applications">
                  <DropdownMenuItem>
                    <IconDesktopOutline className="mr-2 size-4" />
                    Applications
                  </DropdownMenuItem>
                </Link>
              )}
              {isSuperUser(roles) && (
                <Link className="text-foreground" to="/images">
                  <DropdownMenuItem>
                    <IconImageOutline className="mr-2 size-4" />
                    Image library
                  </DropdownMenuItem>
                </Link>
              )}
              {isSuperUser(roles) && (
                <DropdownMenuItem onSelect={() => setSetRedisDialogOpen(true)}>
                  <IconDuplicateOutline className="mr-2 size-4" />
                  Set Redis value
                </DropdownMenuItem>
              )}
            </DropdownMenuGroup>
          )}
          {loggedIn && isSuperUser(roles) && (
            <>
              <DropdownMenuSeparator />
              <DropdownMenuGroup>
                <Link className="text-foreground" to={`apps/showcase/home?appId=2&projectId=2`}>
                  <DropdownMenuItem className="italic text-muted-foreground">
                    <IconLightbulbOutline className="mr-2 size-4" />
                    Components catalog
                  </DropdownMenuItem>
                </Link>
              </DropdownMenuGroup>
            </>
          )}
          {!loggedIn && (
            <DropdownMenuGroup>
              <DropdownMenuItem onSelect={() => window.location.replace(PWC_ID_CONFIG.authUrl())}>
                <IconLoginOutline className="mr-2 size-4" />
                Login
              </DropdownMenuItem>
            </DropdownMenuGroup>
          )}
        </DropdownMenuContent>
      </DropdownMenu>

      {/* Dialog Section */}
      <Dialog modalType="non-modal" open={setRedisDialogOpen} onOpenChange={(e, d) => setSetRedisDialogOpen(d.open)}>
        <DialogSurface aria-describedby={undefined}>
          <form onSubmit={redisFormSubmit}>
            <DialogBody>
              <DialogTitle>Set Redis Value</DialogTitle>
              <DialogContent>
                <Label required htmlFor={'keyinput'}>
                  Key
                </Label>
                <Input required id={'keyinput'} value={key} onChange={(_e, d) => setKey(d.value)} />
                <Label required htmlFor={'valueinput'}>
                  Value
                </Label>
                <Input required id={'valueinput'} value={value} onChange={(_e, d) => setValue(d.value)} />
              </DialogContent>
              <DialogActions>
                <DialogTrigger disableButtonEnhancement>
                  <Button variant="outline" size="sm" onClick={() => setSetRedisDialogOpen(false)}>
                    Cancel
                  </Button>
                </DialogTrigger>
                <Button type="submit" size="sm">
                  Set Value
                </Button>
              </DialogActions>
            </DialogBody>
          </form>
        </DialogSurface>
      </Dialog>
    </>
  )
}
